import React from "react";
import { BudgetSummary } from "../components/SpendAnalyzer";
import AddExpense from "../components/AddExpense";

const Home = ({
  budget,
  categories,
  category,
  amount,
  description,
  setDescription,
  expensesThisMonth,
  setAmount,
  setCategory,
  account,
  setExpensesThisMonth,
  month,
  year,
  setExpensesPaginated
}) => {
  return (
    <div>
      <BudgetSummary
        budget={budget}
        expensesThisMonth={expensesThisMonth}
      />
      <AddExpense
        categories={categories}
        setDescription={setDescription}
        category={category}
        amount={amount}
        description={description}
        setAmount={setAmount}
        setCategory={setCategory}
        account={account}
        expensesThisMonth={expensesThisMonth}
        setExpensesThisMonth={setExpensesThisMonth}
        month={month}
        year={year}
        setExpensesPaginated={setExpensesPaginated}
      />
    </div>
  );
};

export default Home;
